import { get } from 'lodash';
import { createPropsSelectorOrm } from '../utils';

export const getRouteData = createPropsSelectorOrm((session, routeCode) =>
  get(session.Route.withId(routeCode), 'ref')
);
